import { skipToken } from "@reduxjs/toolkit/query";

import { useGetEmployerCurrentOfferDepositByIdQuery } from "@js/apps/employer/api";

import { useEmployerId } from "../employer-id";

export const useGetEmployerCurrentOfferDepositQuery = ({
  skip,
}: { skip?: boolean } = {}) => {
  const employerId = useEmployerId();

  return useGetEmployerCurrentOfferDepositByIdQuery(
    employerId ? employerId : skipToken,
    { skip },
  );
};
